export default __webpack_public_path__ + "static/assets/bf2db6e129195a4b627a9e00a3cd2634.png";